module.exports = __webpack_public_path__ + "img/full3-min.cfb6d720.png";